// MobileWhatWeDo.js
import React from 'react';
import MobileNavigationBar from '../components/mobileNavbar';
import { Container, Card, Row, Col } from 'react-bootstrap';
import MobileFooter from '../components/mobileFooter';
import cityskyline from '../assets/cityskyline.png';
import { PiCurrencyDollarBold } from "react-icons/pi";
import { LuApple } from "react-icons/lu";
import { SlBookOpen } from "react-icons/sl";
import { BsMoonStars } from "react-icons/bs";
import { FaHandHoldingHeart } from "react-icons/fa";
import ExpandableCardList from "../components/expandableCardList";
import SponsorsList from '../components/sponsors';

const IconWrapper = ({ icon }) => (
  <div
    style={{
      backgroundColor: "#336633",
      color: "white",
      borderRadius: "50%",
      width: "40px",
      height: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "absolute",
      top: "-20px",
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 1,
    }}
  >
    {icon}
  </div>
);


const MobileWhatWeDo = () => {
  return (
    <div className="home-page">
      <MobileNavigationBar />
      <div
        style={{
          width: "100%",
          height: "170px",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div
          style={{
            backgroundImage: `url(${cityskyline})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            padding: "10px",
            textAlign: "center",
            color: "black",
            fontFamily: "Lora, sans-serif",
            fontSize: "18px",
            lineHeight: "1.2",
          }}

        >
          <div className="px-4 py-2" style={{ backgroundColor: 'white', outlineColor: 'white', borderRadius: '10px' }}>
            <h1 style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "5px" }}>
              What We Do
            </h1>
            <p style={{ fontSize: "12px" }}>
              The Greater Austin Muslim Relief Committee (GAMRC) is committed to supporting
              the Austin community by offering financial and humanitarian assistance to those
              in need, all in the name of Allah. Through the unity of local masjids and partnerships
              with charitable organizations, we work to provide essential resources to individuals
              and families, ensuring that their needs for food, shelter, medical care, and education are met.
            </p>
          </div>
        </div>
      </div>
      <Container>
        <h4 className='mt-4'>Our Work At GAMRC:</h4>
        <Row className="gx-2 gy-3 justify-content-center text-center mt-3">
          {[
            {
              title: "Financial Assistance",
              icon: <PiCurrencyDollarBold size={20} />,
              items: ["Rent and utilities", "Medical expenses", "Urgent debt"]
            },
            {
              title: "Food Aid",
              icon: <LuApple size={20} />,
              items: ["Distributing food and groceries", "Ramadan food baskets", "Qurbani meat"]
            },
            {
              title: "Educational Programs",
              icon: <SlBookOpen size={20} />,
              items: [
                "Tutoring for underserved children",
                "English tutoring",
                "Quran classes for refugee children",
                "Chromebook funding"
              ]
            },
            {
              title: "Ramadan & Eid Programs",
              icon: <BsMoonStars size={20} />,
              items: [
                "Ramadan groceries",
                "Eid activities",
                "Goodie bags for kids",
                "Henna for girls",
                "Qurbani meat",
                "Zakatul Fitr distribution"
              ]
            },
            {
              title: "Community Engagement",
              icon: <FaHandHoldingHeart size={20} />,
              items: [
                "Furniture, car, and food donation",
                "Eid activities",
                "School break programs"
              ]
            }
          ].map((item, idx) => (
            <Col xs={12} key={idx}>
              <Card
                className="h-100 shadow p-1 pt-3 mx-4 "
                style={{ position: "relative", backgroundColor: "white", minHeight: "100%" }}
              >
                <IconWrapper icon={item.icon} />
                <Card.Title>
                  <h6 style={{ fontWeight: "600", color: "#336633", fontSize: "14px", marginTop: "8px" }}>
                    {item.title}
                  </h6>
                </Card.Title>
                <Card.Body className="pt-0 px-4 pb-4" style={{ padding: "0 0px" }}>
                  <ul
                    className="text-start"
                    style={{ paddingLeft: "16px", fontSize: "14px", marginBottom: "0" }}
                  >
                    {item.items.map((text, i) => (
                      <li key={i}  style={{ marginBottom: "4px", fontSize: "14px" }}>{text}</li>
                    ))}
                  </ul>

                  {/* Add buttons only for Ramadan & Eid Programs */}
                  {item.title === "Ramadan & Eid Programs" && (
                     <div className="mt-auto d-flex justify-content-end">
                                <a
                                    href="/Eid"
                                    style={{
                                        color: '#294d29ff',
                                        fontFamily: 'Lora, serif',
                                        textDecoration: 'none',
                                        fontSize: '14px',
                                    }}
                                >
                                    More Details →
                                </a>
                            </div>
                  )}
                   {item.title === "Educational Programs" && (
                     <div className="mt-auto d-flex justify-content-end">
                                <a
                                    href="/Education"
                                    style={{
                                        color: '#294d29ff',
                                        fontFamily: 'Lora, serif',
                                        textDecoration: 'none',
                                        fontSize: '14px',
                                    }}
                                >
                                    More Details →
                                </a>
                            </div>
                  )}


                </Card.Body>

              </Card>
            </Col>
          ))}
        </Row>


        <Col md={6} sm={12} className="mb-4 text-center align-self-center mx-4 mt-4">
          <hr
            className="my-2"
            style={{
              border: "1px solid black",
              height: "1px",
              opacity: "1",
              width: "30vh",
              borderRadius: "5px",
              margin: "auto",
            }}
          />
          <h4>
            "Is there any reward for good other than good?" <br />
            — Surah Ar-Rahman (55:60)
          </h4>
          <p style={{ fontSize: "14px" }}>
            Uplift your Austin Muslim community. Volunteer your time, share your kindness, and be part of a cycle of
            goodness.
          </p>
          <hr
            className="my-2"
            style={{
              border: "1px solid black",
              height: "1px",
              opacity: "1",
              width: "30vh",
              borderRadius: "5px",
              margin: "auto",
            }}
          />
        </Col>
        <h4>GAMRC Also Supports:</h4>
        <ExpandableCardList />
        <hr style={{ height: '2px', backgroundColor: 'black' }} />
        <h4 className="mb-1 text-center">Our Sponsors</h4>
        <p style={{ fontSize: "18px", lineHeight: "1.6", textAlign: "center" }}>
          JazakAllah to our sponsors for their generous support and contributions to the Greater Austin Muslim Relief Committee.
          Their commitment to our mission helps us serve the community effectively.
        </p>
        <SponsorsList />
      </Container>
      <MobileFooter />
    </div>
  );
};

export default MobileWhatWeDo;
